// @flow
// import * as ActionCable from 'actioncable';
import ActionCable from 'actioncable';

class App {
  cable = ActionCable.createConsumer();
  //
  // // $FlowFixMe
  // get cable(): any {
  //   return this.cable;
  // }
  //
}

export default new App();
